module.exports = __webpack_public_path__ + "static/media/Flat Tyre Assistance.824f5a0f.png";